import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import {
	RubricEvaluatorOption,
	RubricEvaluatorOptionType
} from '@go-modules/interfaces/rubrics/rubric';

@Component({
	selector: 'rubric-filter-dropdown',
	templateUrl: './rubric-filter-dropdown.component.html',
	styleUrls: ['./rubric-filter-dropdown.component.scss'],
	standalone: false
})
export class RubricFilterDropdownComponent implements OnChanges, OnInit {
	@Input() public rubrics: RubricEvaluatorOption[];
	@Input() public initial: RubricEvaluatorOption;
	@Output() public rubricChange: EventEmitter<RubricEvaluatorOption>  = new EventEmitter();
	public selected: RubricEvaluatorOption;

	public ngOnInit () {
		this.syncSelected();
	}

	public ngOnChanges () {
		this.syncSelected();
	}

	public updated (rubric: RubricEvaluatorOption) {
		this.rubricChange.next(rubric);
	}

	public compareOptions (first: RubricEvaluatorOption, second: RubricEvaluatorOption): boolean {
		return first?.id === second?.id;
	}

	public isUnposted (option: RubricEvaluatorOption): boolean {
		return option.type === RubricEvaluatorOptionType.HUMAN && option.rubric.isPublished?.() === false;
	}

	public shouldShowScore (option: RubricEvaluatorOption): boolean {
		const rubric = option.rubric;

		return rubric != null && !rubric.hideScore && rubric.points != null;
	}

	public scoreText (option: RubricEvaluatorOption): string {
		const rubric = option.rubric;

		return rubric == null ? '' : `${rubric.points} / ${rubric.total}`;
	}

	private syncSelected (): void {
		if (this.initial == null) {
			this.selected = this.rubrics?.[0];
			return;
		}

		this.selected = this.rubrics?.find((rubric) => rubric.id === this.initial.id) ?? this.initial;
	}
}
